import { MoonOutlined, SunOutlined } from '@ant-design/icons';
import { Segmented } from 'antd';
import type { SizeType } from 'antd/es/config-provider/SizeContext';
import { ThemeMode, useThemePreference } from '../../state/use-theme-preference';

type Props = {
  size?: SizeType;
};

export const ThemeSwitcher = ({ size }: Props) => {
  const mode = useThemePreference((s) => s.mode);
  const setMode = useThemePreference((s) => s.setMode);

  return (
    <Segmented<ThemeMode>
      size={size}
      value={mode}
      onChange={setMode}
      options={[
        { label: 'Light', value: ThemeMode.Light, icon: <SunOutlined /> },
        { label: 'Dark', value: ThemeMode.Dark, icon: <MoonOutlined /> },
      ]}
    />
  );
};
